import entries from "lodash/entries";
import keys from "lodash/keys";
import { IconMetadata, IconVariants } from "@/src/easy-icons/types";
import { defineAsyncComponent } from "vue";

const files = import.meta.glob("@/src/easy-icons/icons/**/*.vue");

const _defineAsyncComponent = (size: number, variant: IconVariants, fileName: string) => {
  return keys(files).some(file => file.includes(`icons/${size}/${variant}/icons/${fileName}.vue`))
    ? defineAsyncComponent(() => import(`@/src/easy-icons/icons/${size}/${variant}/icons/${fileName}.vue`))
    : null;
};

export const iconComponentManager = (iconNames: Record<string, string>, variant: IconVariants, size: number) => {
  return entries(iconNames).reduce(
    (acc, [key, fileName]) => {
      acc[key] = _defineAsyncComponent(size, variant, fileName);
      return acc;
    },
    {} as Record<string, ReturnType<typeof defineAsyncComponent> | null>
  );
};

export const generateIconsForSizes = (iconVariants: IconMetadata[], uniqueIcons: Record<string, string>) => {
  return iconVariants.reduce(
    (acc, { size, path, name }) => {
      acc[name] = iconComponentManager(uniqueIcons, path, size);
      return acc;
    },
    {} as Record<string, Record<string, ReturnType<typeof defineAsyncComponent> | null>>
  );
};
